import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { LoginPage } from './login';
import { PipesModule } from '../../../pipes/pipes.module';
import { FoundationModule } from '../../../_foundation/foundation.module';
import { DirectivesModule } from '../../../directives/directives.module';

@NgModule({
  declarations: [
    LoginPage,
  ],
  imports: [
    DirectivesModule,
    IonicPageModule.forChild(LoginPage),
    PipesModule,
    FoundationModule,
  ],
})
export class LoginPageModule {
}



// WEBPACK FOOTER //
// ./src/pages/auth/login/login.module.ts